export default __webpack_public_path__ + "static/media/thisiscanonandnoiwillnotbetakingquestions.d2e466cb.gif";